var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.39 76.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.5,23.23c-.4,0-.5-.2-.3-.5l2.1-2.7c.2-.3,.7-.5,1.1-.5H54.1c.4,0,.5,.3,.3,.6l-1.7,2.6c-.2,.3-.7,.6-1,.6l-36.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.4,32.43C0,32.43-.1,32.23,.1,31.93l2.1-2.7c.2-.3,.7-.5,1.1-.5H48.9c.4,0,.6,.3,.5,.6l-.8,2.4c-.1,.4-.5,.6-.9,.6l-47.3,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6,41.63c-.4,0-.5-.3-.3-.6l1.4-2.5c.2-.3,.6-.6,1-.6h20c.4,0,.6,.3,.6,.7l-.2,2.4c0,.4-.4,.7-.7,.7l-21.8-.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CXHf1q"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.4,21.43c-6.3,1.6-10.6,2.8-16.8,4.4-1.5,.4-1.6,.5-2.9-1-1.5-1.7-2.6-2.8-4.7-3.8-6.3-3.1-12.4-2.2-18.1,1.5-6.8,4.4-10.3,10.9-10.2,19,.1,8,5.6,14.6,13.5,15.7,6.8,.9,12.5-1.5,17-6.6,.9-1.1,1.7-2.3,2.7-3.7h-19.3c-2.1,0-2.6-1.3-1.9-3,1.3-3.1,3.7-8.3,5.1-10.9,.3-.6,1-1.6,2.5-1.6h36.4c-.2,2.7-.2,5.4-.6,8.1-1.1,7.2-3.8,13.8-8.2,19.6-7.2,9.5-16.6,15.4-28.5,17-9.8,1.3-18.9-.6-26.9-6.6-7.4-5.6-11.6-13-12.7-22.2-1.3-10.9,1.9-20.7,8.5-29.3,7.1-9.3,16.5-15.2,28-17.3,9.4-1.7,18.4-.6,26.5,4.9,5.3,3.5,9.1,8.3,11.6,14.1,.6,.9,.2,1.4-1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.5,76.73c-9.1-.2-17.4-2.8-24.4-8.8-5.9-5.1-9.6-11.6-10.8-19.3-1.8-11.3,1.3-21.3,8.1-30.2,7.3-9.6,16.1-14.6,28-16.7,10.2-1.8,19.8-.8,28.5,5.1,7.9,5.4,12.8,12.7,14.1,22.3,1.7,13.5-2.2,24.5-11.5,33.9-6.6,6.7-14.7,10.9-24,12.8-2.7,.5-5.4,.6-8,.9Zm23.8-40.4c-.1-1.3-.1-2.3-.3-3.3-1.8-9.9-10.9-15.5-20.4-13.3-9.3,2.1-15.3,8-17.5,17.4-1.8,7.8,2,15.7,9.2,18.9,5.5,2.4,11,2.1,16.3-.6,7.9-4.1,12.2-10.5,12.7-19.1Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo1);
export default __webpack_public_path__ + "static/media/go_1.7c53a872b991921be60b6e6ee1a9e2d7.svg";
export { ForwardRef as ReactComponent };